var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCustomNumberFieldBlank = function SvgCustomNumberFieldBlank(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33594 11.5V4.5L7.02344 11.5V4.5M10.2734 11.5H14.3359M10.2734 6.6C10.2734 7.15695 10.4874 7.6911 10.8684 8.08492C11.2493 8.47875 11.766 8.7 12.3047 8.7C12.8434 8.7 13.3601 8.47875 13.741 8.08492C14.1219 7.6911 14.3359 7.15695 14.3359 6.6C14.3359 6.04305 14.1219 5.5089 13.741 5.11508C13.3601 4.72125 12.8434 4.5 12.3047 4.5C11.766 4.5 11.2493 4.72125 10.8684 5.11508C10.4874 5.5089 10.2734 6.04305 10.2734 6.6Z",
    stroke: "currentColor",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCustomNumberFieldBlank);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "custom-number-field-blank.7f9b3aa78a861237265fd35a66f2426e.svg";